// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { getType } from 'typesafe-actions';

import { WorkshopInformation } from '../../types/Model';
import { actionCreatorsList, RootAction } from '../rootActionCreator';

export interface WorkshopInformationState {
  workshops: Record<number, WorkshopInformation>;
  isInformationFetching: boolean;
  isProgressing: boolean;
  isEnding: boolean;
  error?: Error;
}

const { getWorkshopDataActions } = actionCreatorsList;

export const initialState: WorkshopInformationState = {
  workshops: {},
  isInformationFetching: false,
  isProgressing: false,
  isEnding: false,
};

const workshopDataReducer = (state = initialState, action: RootAction): WorkshopInformationState => {
  switch (action.type) {
    case getType(getWorkshopDataActions.request): {
      return {
        ...state,
        isInformationFetching: !action.payload.preventLoading,
        error: undefined
      };
    }
    case getType(getWorkshopDataActions.success): {
      const { payload } = action;
      const workshop = payload.workshopData;
      return {
        ...state,
        isInformationFetching: false,
        workshops: { [workshop.id]: workshop },
      };
    }
    case getType(getWorkshopDataActions.failure): {
      return {
        ...state,
        isInformationFetching: false,
        error: action.payload.error,
      };
    }

    default: {
      return state;
    }
  }
}
export { workshopDataReducer as default};
